import { getResourceSign } from 'resfull/npgw/cms/imgLib';
//sessionStorage 存的是通用sign
class ResourceSign {
    constructor() {
        this._currentRequestPromise = null; // 当前正在进行的请求Promise
    }

    async getSign() {
        // 如果已有请求正在进行，直接返回相同的Promise
        if (this._currentRequestPromise) {
            console.debug('当前正在获取sign，请稍后');
            return this._currentRequestPromise;
        }
        
        // 创建新的请求Promise
        this._currentRequestPromise = this._executeGetSign();
        
        // 无论成功或失败，都要清理当前Promise
        this._currentRequestPromise.finally(() => {
            this._currentRequestPromise = null;
        });
            
        return this._currentRequestPromise;
    }

    /**
     * 执行实际的签名获取逻辑
     * @private
     */
    async _executeGetSign() {
        try {
            let authorization = this.getSessionItem('Authorization');
            
            // 如果缓存中有有效值，直接返回
            if (authorization) {
                return authorization;
            }
            
            // 否则调用API获取新签名
            authorization = await this.getSignAjax();
            
            return authorization || '';
        } catch (error) {
            console.error('获取签名时发生错误:', error);
            return '';
        }
    }
    //获取后台通用sign
    async getSignAjax() {
        try {
            const {code, expire, sign} = await getResourceSign();
            if (code === '200') {
                this.setSessionItem('Authorization', sign, expire);
                return sign;
            } else {
                console.warn(`获取签名失败，状态码: ${code}`);
                this.clearAuthorization('Authorization');
                return '';
            }
        } catch (error) {
            console.error('调用获取签名API时发生错误:', error);
            throw error;
        }
    }

    // 存储带有时效性的数据
    setSessionItem(key, value, expirationInSeconds) {
        const now = new Date();
        const item = {
            value: value,
            expirationTime: now.getTime() + (expirationInSeconds * 1000),
        };
        try {
            sessionStorage.setItem(key, JSON.stringify(item));
            this.Authorization = JSON.stringify(item); // 同步更新内存中的值
        } catch (error) {
            console.error('存储到sessionStorage时发生错误:', error);
        }
    }
     
    // 获取数据，检查是否过期
    getSessionItem(key) {
        const itemStr = this.Authorization || sessionStorage.getItem(key);
        if (!itemStr) {
            return null;
        }    
        try {
            const item = JSON.parse(itemStr);
            const now = new Date();
            // 检查是否即将过期（提前2分钟）
            if (now.getTime() + 120 * 1000 > item.expirationTime) {
                this.clearAuthorization('Authorization');
                return null;
            }     
            return item.value;
        } catch (error) {
            console.error('解析sessionStorage数据时发生错误:', error);
            this.clearAuthorization('Authorization');
            return null;
        }
    }

    clearAuthorization() {
        this.Authorization = '';
        try {
            sessionStorage.removeItem('Authorization');
        } catch (error) {
            console.error('清除sessionStorage时发生错误:', error);
        }
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new ResourceSign();
        }
        return this.instance;
    }
}

export function resourceSign() {
    return ResourceSign.getInstance().getSign(...arguments);
}
export function getSignAjax() {
    return ResourceSign.getInstance().getSignAjax(...arguments);
}
export function clearJwt() {
    return ResourceSign.getInstance().clearAuthorization();
}
